import { render, staticRenderFns } from "./DialogNewQuantityTable.vue?vue&type=template&id=89f12c84&scoped=true"
import script from "./DialogNewQuantityTable.vue?vue&type=script&lang=ts"
export * from "./DialogNewQuantityTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f12c84",
  null
  
)

export default component.exports